import { render, staticRenderFns } from "./PorletFormularioHorizontal.vue?vue&type=template&id=c6628f64&"
import script from "./PorletFormularioHorizontal.vue?vue&type=script&lang=js&"
export * from "./PorletFormularioHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./PorletFormularioHorizontal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports